import type { ArdoqId } from '@ardoq/api-types';
import { isTruthy } from '@ardoq/common-helpers';
import { uniq } from 'lodash';
import {
  ComponentMatrixGroupOwnerType,
  type ComponentMatrixGroup,
} from '../types';
import { COMPONENT_HIERARCHY_PADDING } from '../consts';
import type { ViewpointModeComponentMatrixViewModel } from './types';

/**
 * The component a header group renders, or null when the group renders none: a
 * list-field value, or the padding that fills a reference slot out to the axis
 * depth. Owner types are assigned per address position, so a padding slot on a
 * reference axis is REFERENCED_COMPONENT too.
 */
const toHeaderComponentId = (group: ComponentMatrixGroup): ArdoqId | null => {
  if (group.ownerType !== ComponentMatrixGroupOwnerType.REFERENCED_COMPONENT) {
    return null;
  }
  const token = group.address.at(-1);
  if (!token || token === COMPONENT_HIERARCHY_PADDING) return null;
  return token;
};

const headerComponentIds = (
  groups: Map<string | null, ComponentMatrixGroup>
): ArdoqId[] =>
  [...groups.values()].flatMap(group =>
    [toHeaderComponentId(group), ...headerComponentIds(group.children)].filter(
      isTruthy
    )
  );

export const getComponentMatrix2ViewComponentIds = ({
  items,
  rows,
  columns,
}: ViewpointModeComponentMatrixViewModel): ArdoqId[] =>
  uniq([
    ...items.map(({ componentId }) => componentId),
    ...headerComponentIds(rows),
    ...headerComponentIds(columns),
  ]);
